const isValidEmail = (value) => {
    if (!value || value.length > 254) return false;

    const parts = value.split('@');
    if (parts.length !== 2) return false;

    const [local, domain] = parts;

    if (!local || !domain) return false;
    if (local.length > 64 || domain.length > 255) return false;

    if (/\s/.test(local) || /\s/.test(domain)) return false;

    if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) return false;
    if (domain.startsWith('.') || domain.endsWith('.') || domain.includes('..')) return false;

    if (!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/.test(local)) return false;
    return /^[^\s@]+\.[^\s@]{2,}$/.test(domain);
};

export default isValidEmail;
